import { ColumnProps } from "antd/lib/table";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CommenQuestionContext from "../../../context/commen-question/context";
import Space from "../../general/antd/space";
import ViewBtn from "../../general/table-components/actions/view-btn";
import EditBtn from "../../general/table-components/actions/edit-btn";
import DeleteBtn from "../../general/table-components/actions/delete-btn";
import eventManager, { EVENT_SUCCESS } from "../../../utils/events";
import { ISort, IStaticFilter } from "../../../models/base/base-query";
import { tableOnChange } from "../../../utils/helpers/table-sorts-filters";
import Table from "../../general/table-components/table";
import { ICommenQuestion } from "../../../models/commen-question/response";
import Tag from "../../general/antd/tag";
import { getFor, getForColor } from "../../../models/commen-question/enum";
import styles from './styles.module.scss';
interface IProps { }

const CommenQuestionTable: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { list, actions, loading, query } = useContext(CommenQuestionContext);

  const columns: ColumnProps<ICommenQuestion>[] = [
    {
      title: t("id"),
      dataIndex: "id",
      key: "id",
      sorter: {
        multiple: 1,
      },
      width: 100,
      align: "center",
    },
    {
      title: t("question"),
      dataIndex: "question",
      align: "center",
      key: "question",
      minWidth:120,
      sorter: {
        multiple: 2,
      },
    },
    {
      title: t("answer"),
      dataIndex: "answer",
      align: "center",
      key: "answer",
      minWidth:200,
      sorter: {
        multiple: 3,
      },
    },
    {
      title: t("for"),
      dataIndex: "for",
      align: "center",
      key: "for",
      render: (_, recode) => {
        return (
          <Tag
            color={getForColor(recode?.for)}
            title={getFor(recode?.for)}
          />
        );
      },
    },
    {
      title: t("actions"),
      width: 250,
      dataIndex: "",
      align: "center",
      key: "x",
      render: (_: any, record) => (
        <Space>
          <ViewBtn
              onClick={(e) => {
                const url = `/commen-questions/details/${record?.id}`;
                if (e.ctrlKey || e.metaKey) {
                  window.open(url, "_blank");
                } else {
                  navigate(url);
                }
              }}
            />
            <EditBtn
              onClick={(e) => {
                const url = `/commen-questions/update/${record?.id}`; 
                if (e.ctrlKey || e.metaKey) {
                  window.open(url, "_blank");
                } else {
                  navigate(url);
                }
              }}
            />
          <DeleteBtn
            onConfirm={async () => {
              await actions.deleteCommenQuestion(record?.id);
              eventManager.emit(EVENT_SUCCESS);
            }}
            loading={loading.includes("delete")}
          />
        </Space>
      ),
    },
  ];

  // Filters && Sorts
  let tableFiltersProps = {};
  const [sorts, setSorts] = useState<ISort[]>([]);
  const [, setStaticFilters] = useState<IStaticFilter[]>(query?.filters ?? []);

  useEffect(() => {
    sorts.length > 0 &&
      actions.setQuery({
        ...query,
        orders: sorts,
      });
  }, [sorts]);

  return (
    <>
      <Table<any>
        rowKey="id"
        showPagination={true}
        columns={columns}
        className={styles.table}
        dataSource={list?.data ?? []}
        loading={loading.includes("list") || list == undefined}
        size="small"
        total={list?.total}
        pageSize={query.perPage}
        page={query.page}
        onPaginationChange={(page, pageSize) => {
          actions.setQuery({
            ...query,
            page,
            perPage: pageSize,
          });
        }}
        onChange={(_, tableFilters, tabelSorters) => {
          tableOnChange(
            tableFilters,
            tabelSorters,
            tableFiltersProps,
            setSorts,
            setStaticFilters
          );
        }}
      />
    </>
  );
};

export default CommenQuestionTable;
